import { TextSkeletonComponent } from './text-skeleton.component';

export default angular
  .module('sfMobile.components.text-skeleton', [])
  .component('sfTextSkeleton', TextSkeletonComponent).name;
